import React from "react";
import Icon from "@mdi/react";

type SummaryItemProps = {
  icon: string;
  label: string;
  value?: string;
  color?: string;
};

const SummaryItem: React.FC<SummaryItemProps> = ({
  icon,
  label,
  value,
  color = "text-gray-600",
}) => (
  <div className="flex items-center gap-2">
    <Icon path={icon} size={0.8} className={color} />
    <div>
      <p className="text-xs text-gray-500">{label}</p>
      <p className="font-medium">{value ?? "-"}</p>
    </div>
  </div>
);

export default SummaryItem;
